import { clamp } from "./math";

export function oklch(l: number, c: number, h: number) {
  return rgbToHex(lrgbToRgb(oklabToLrgb(oklchToOklab({ l, c, h }))));
}

/**
 * Convert OKLCH to OKLAB
 */
function oklchToOklab({ l, c, h }: OKLCH): OKLAB {
  let res = {
    l,
    a: c ? c * Math.cos((h / 180) * Math.PI) : 0,
    b: c ? c * Math.sin((h / 180) * Math.PI) : 0,
  };
  return res;
}

/**
 * Convert OKLAB to Liner SRGB
 */
function oklabToLrgb({ l, a, b }: OKLAB): RGB {
  let L = Math.pow(l * 0.99999999845051981432 + 0.39633779217376785678 * a + 0.21580375806075880339 * b, 3);
  let M = Math.pow(l * 1.0000000088817607767 - 0.1055613423236563494 * a - 0.063854174771705903402 * b, 3);
  let S = Math.pow(l * 1.0000000546724109177 - 0.089484182094965759684 * a - 1.2914855378640917399 * b, 3);

  let res = {
    r: +4.076741661347994 * L - 3.307711590408193 * M + 0.230969928729428 * S,
    g: -1.2684380040921763 * L + 2.6097574006633715 * M - 0.3413193963102197 * S,
    b: -0.004196086541837188 * L - 0.7034186144594493 * M + 1.7076147009309444 * S,
  };

  return res;
}

function lrgbComponentToRgb(c = 0) {
  const abs = Math.abs(c);
  if (abs > 0.0031308) {
    return (Math.sign(c) || 1) * (1.055 * Math.pow(abs, 1 / 2.4) - 0.055);
  }
  return c * 12.92;
}

function lrgbToRgb({ r, g, b }: RGB): RGB {
  let res = {
    r: lrgbComponentToRgb(r),
    g: lrgbComponentToRgb(g),
    b: lrgbComponentToRgb(b),
  };
  return res;
}

function componentToHex(c: number) {
  let hex = Math.round(clamp(c * 255, 0, 255)).toString(16);
  return hex.length == 1 ? "0" + hex : hex;
}

function rgbToHex({ r, g, b }: RGB) {
  return "#" + componentToHex(r) + componentToHex(g) + componentToHex(b);
}

type OKLCH = {
  l: number;
  c: number;
  h: number;
};

type OKLAB = {
  l: number;
  a: number;
  b: number;
};

type RGB = {
  r: number;
  g: number;
  b: number;
};
